import React from 'react'
import { BasicTable } from './BasicTable.react'
import { Pagination } from './Pagination.react'

export const DataTable = ({ sortColumn = null, sortOrder = null, currentPage, totalItems, limit, updateLocation, headers, columns, data }) => {
  const changePage = (pageNumber) => {
    if (pageNumber !== currentPage) {
      updateLocation({ page: pageNumber, sortColumn, sortOrder })
    }
  }

  const changeSort = (sortColumn) => updateLocation({
    page: currentPage,
    sortColumn,
    sortOrder: shouldAscend(sortColumn) ? 'ascending' : 'descending'
  })

  const isActiveSort = (newColumn) => newColumn === sortColumn
  const isAscending = (newColumn) => isActiveSort(newColumn) && sortOrder === 'ascending'
  const isDescending = (newColumn) => isActiveSort(newColumn) && !isAscending(newColumn)
  const shouldAscend = (newColumn) => {
    if (isActiveSort(newColumn)) {
      return isDescending(newColumn)
    } else {
      return false
    }
  }

  return (
    <>
      <BasicTable
        headers={headers}
        columns={columns}
        data={data}
        changeSortFn={changeSort}
        isAscending={isAscending}
        isDescending={isDescending}
      />
      <Pagination
        currentPage={currentPage}
        totalItems={totalItems}
        limit={limit}
        changePage={changePage}
      />
    </>
  )
}
